import React, {FC} from 'react';
import cn from 'classnames';
import {useLocalizer} from '@/common/services/localizer';
import styles from './ConditionLargeIcon.css';

const getIconUrl = (
	condition: number,
	isNight: boolean | undefined,
	pixelRatio: '2x' | '1x',
	format: 'png' | 'webp',
) => {
	// eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-var-requires
	return require(`./icons/${pixelRatio}/${isNight ? 'n' : 'd'}${condition}.${format}`).default;
};

interface ConditionLargeIconProps {
	className?: string;
	condition: number;
	isNight?: boolean;
}

export const ConditionLargeIcon: FC<ConditionLargeIconProps> = props => {
	const {className, condition, isNight} = props;

	const t = useLocalizer();

	const iconUrl = getIconUrl(condition, isNight, '1x', 'png');
	const icon2xUrl = getIconUrl(condition, isNight, '2x', 'png');
	const iconWebpUrl = getIconUrl(condition, isNight, '1x', 'webp');
	const icon2xWebpUrl = getIconUrl(condition, isNight, '2x', 'webp');

	return (
		<picture className={cn(styles.root, className)}>
			<source srcSet={`${iconWebpUrl}, ${icon2xWebpUrl} 2x`} type='image/webp' />
			<img
				className={styles.image}
				src={iconUrl}
				srcSet={`${icon2xUrl} 2x`}
				alt={t(`weatherConditions.${condition}`)}
			/>
		</picture>
	);
};

ConditionLargeIcon.displayName = 'ConditionLargeIcon';
